export default __webpack_public_path__ + "static/media/Superdiversity-website-metadata-Vancouver.13631a67.pdf";